import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  PassThroughAdapterdbgnfuhbpbsv as PassThroughAdapter,
  get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter,
  get_FloatAdapter8hkphxq3v57l as get_FloatAdapter,
  get_LongAdapter1acs38m0a7icu as get_LongAdapter,
  get_DoubleAdapter3vjvxl0ttbawu as get_DoubleAdapter,
  get_IntAdapter2kzerdn7hhunh as get_IntAdapter,
  get_BooleanAdapterefxw889yjdy4 as get_BooleanAdapter,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_UploadAdapter1jp2f4wtvjtde as get_UploadAdapter,
} from './Adapters.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from './ExecutionContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {
      constructor() {
        Key_instance = this;
        this.a46_1 = (new (Builder())()).p37();
        this.b46_1 = (new (Builder())()).h46(true).p37();
      }
    }
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  if (Key_instance === VOID)
    new (Key())();
  return Key_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.c46_1 = LinkedHashMap().bc();
        this.d46_1 = false;
        this.e46_1 = null;
        this.f46_1 = null;
        this.g46_1 = null;
      }
      i46(falseVariables) {
        // Inline function 'kotlin.apply' call
        this.e46_1 = falseVariables;
        return this;
      }
      j46(deferredFragmentIdentifiers) {
        // Inline function 'kotlin.apply' call
        this.f46_1 = deferredFragmentIdentifiers;
        return this;
      }
      k44(errors) {
        // Inline function 'kotlin.apply' call
        this.g46_1 = errors;
        return this;
      }
      k46(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.c46_1.z4(customScalarAdapters.p46_1);
        return this;
      }
      h46(unsafe) {
        // Inline function 'kotlin.apply' call
        this.d46_1 = unsafe;
        return this;
      }
      a5() {
        this.c46_1.a5();
      }
      p37() {
        return new (CustomScalarAdapters())(this.c46_1, this.e46_1, this.f46_1, this.g46_1, this.d46_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CustomScalarAdaptersClass;
function CustomScalarAdapters() {
  if (CustomScalarAdaptersClass === VOID) {
    class $ {
      constructor(customScalarAdapters, falseVariables, deferredFragmentIdentifiers, errors, unsafe) {
        Key_getInstance();
        this.l46_1 = falseVariables;
        this.m46_1 = deferredFragmentIdentifiers;
        this.n46_1 = errors;
        this.o46_1 = unsafe;
        this.p46_1 = customScalarAdapters;
      }
      q46(customScalar) {
        var tmp;
        if (!(this.p46_1.u4(customScalar.x45_1) == null)) {
          tmp = this.p46_1.u4(customScalar.x45_1);
        } else if (customScalar.w45_1 === 'com.apollographql.apollo.api.Upload') {
          tmp = get_UploadAdapter();
        } else if (listOf(['kotlin.String', 'java.lang.String']).t2(customScalar.w45_1)) {
          tmp = get_StringAdapter();
        } else if (listOf(['kotlin.Boolean', 'java.lang.Boolean']).t2(customScalar.w45_1)) {
          tmp = get_BooleanAdapter();
        } else if (listOf(['kotlin.Int', 'java.lang.Int']).t2(customScalar.w45_1)) {
          tmp = get_IntAdapter();
        } else if (listOf(['kotlin.Double', 'java.lang.Double']).t2(customScalar.w45_1)) {
          tmp = get_DoubleAdapter();
        } else if (listOf(['kotlin.Long', 'java.lang.Long']).t2(customScalar.w45_1)) {
          tmp = get_LongAdapter();
        } else if (listOf(['kotlin.Float', 'java.lang.Float']).t2(customScalar.w45_1)) {
          tmp = get_FloatAdapter();
        } else if (listOf(['kotlin.Any', 'java.lang.Object']).t2(customScalar.w45_1)) {
          tmp = get_AnyAdapter();
        } else if (this.o46_1) {
          tmp = new (PassThroughAdapter())();
        } else {
          // Inline function 'kotlin.error' call
          var message = "Can't map GraphQL type: `" + customScalar.x45_1 + '` to: `' + customScalar.w45_1 + '`. Did you forget to add a scalar Adapter?';
          throw IllegalStateException().o(toString(message));
        }
        var tmp_0 = tmp;
        return (!(tmp_0 == null) ? isInterface(tmp_0, Adapter()) : false) ? tmp_0 : THROW_CCE();
      }
      m3() {
        return Key_getInstance();
      }
      v43() {
        return (new (Builder())()).k46(this).i46(this.l46_1).j46(this.m46_1);
      }
    }
    protoOf($).r46 = get;
    protoOf($).s46 = fold;
    protoOf($).t46 = minusKey;
    protoOf($).i44 = plus;
    initMetadataForClass($, 'CustomScalarAdapters', VOID, VOID, [Element()]);
    CustomScalarAdaptersClass = $;
  }
  return CustomScalarAdaptersClass;
}
//region block: exports
export {
  Builder as Builder4ra56zvvku0a,
  Key_getInstance as Key_getInstance4887rkxhu93r,
};
//endregion

//# sourceMappingURL=CustomScalarAdapters.mjs.map
